
import { Link } from 'react-router-dom';

const ChoosePlanUnlock = ({ isGiftMode, showModal }) => {

    return (
        <section id="plans" className="py-4 py-sm-5">
            <div className="container">
                <div className="row text-center">
                    <div className="row text-center py-5">
                            <h2 className="my-2 fw-bold text-blue">Stay Informed Without Censorship</h2>
                            <h3 className="my-2 fw-medium text-black">No Contracts. Cancel Anytime.</h3>
                            <Link className='nm-btn w-auto py-2 px-5 text-white bg-accent shadow-md rounded' to="/checkout/annually">Start Your FREE Trial</Link>
                        </div>
                    <div className="d-flex flex-column flex-md-row justify-content-evenly align-items-start py-4">

                        <div className="col-12 col-md-5 shadow p-0 bg-body my-3 my-md-0 position-relative border border-2 border-danger plan-card" style={{ borderTop: "6px solid #FF0000!important" }}>
                            <div className="recommended-tag"><img src="/images/logos/recommended-tag-red.webp" alt="recommended tag" className="img-fluid" /></div>
                            <div className="mt-5 py-3 text-blue">
                                <h4 className="text-black text-uppercase">Yearly Plan</h4>
                                <img fetchpriority="high" src="/images/logos/nmx-plus-logo.webp" alt="Newsmax+ Logo" className="img-fluid w-100 d-block mt-2 mb-3 mx-auto px-3" style={{ maxWidth: "300px" }} />
                                <h4 className="display-1 text-accent fw-semibold mb-0">$49.99</h4>
                                <h4 className="text-black mt-0 mb-4 pt-0">/ year</h4>
                                <h4 className="display-4 fw-semibold text-black-50 slash">$59.88</h4>
                                <h5 className="display-5 text-black fw-medium mb-4">Save <span className="text-accent fw-semibold">$10</span></h5>
                            </div>
                            <div className="pb-2 ps-4 ps-md-5 text-start text-black lh-1">
                                <p><span className="nm-check" aria-hidden="true" /> Exclusive Content</p>
                                <p><span className="nm-check" aria-hidden="true" /> Breaking News and Expert Analysis</p>
                                <p><span className="nm-check" aria-hidden="true" /> Access to World at War Channel</p>
                                <p><span className="nm-check" aria-hidden="true" /> Affordable Pricing</p>
                                <p><span className="nm-check" aria-hidden="true" /> Access From Anywhere, Any Device</p>
                                <p><span className="nm-check" aria-hidden="true" /> 15-Day Trial</p>
                                <p><span className="nm-check" aria-hidden="true" /> Just $4.17/month (billed annually)</p>
                            </div>
                            <Link className='nm-btn w-full w-sm-auto py-2 px-5 mb-5 text-white bg-accent shadow-md rounded' to="/checkout/annually">Start Your FREE Trial</Link>

                        </div>
                        {!isGiftMode && (
                            <div className="col-12 col-md-5 border shadow p-0 bg-light my-3 my-md-0 border-2 border-secondary-subtle plan-card">
                                <div className="mt-5 py-3 text-blue">
                                    <h4 className="text-black text-uppercase">Monthly Plan</h4>
                                    <img fetchpriority="high" src="/images/logos/nmx-plus-logo.webp" alt="Newsmax+ Logo" className="img-fluid w-100 d-block mt-2 mb-3 mx-auto px-3" style={{ maxWidth: "300px" }} />
                                    <h4 className="display-1 text-black fw-semibold mb-0">$4.99</h4>
                                    <h4 className="text-black mt-0 mb-4 pt-0">/ month</h4>
                                </div>
                                <div className="pb-2 ps-4 ps-md-5 text-start text-black lh-1">
                                    <p><span className="nm-check" aria-hidden="true" /> Exclusive Content</p>
                                    <p><span className="nm-check" aria-hidden="true" /> Breaking News and Expert Analysis</p>
                                    <p><span className="nm-check" aria-hidden="true" /> Access to World at War Channel</p>
                                    <p><span className="nm-check" aria-hidden="true" /> Affordable Pricing</p>
                                    <p><span className="nm-check" aria-hidden="true" /> Access From Anywhere, Any Device</p>
                                    <p><span className="nm-check" aria-hidden="true" /> 15-Day Trial</p>
                                </div>
                                <Link className='nm-btn border border-2 border-accent bg-transparent w-full w-sm-auto py-2 px-5 mb-5 text-accent shadow-md rounded' to="/checkout/monthly">Start Your FREE Trial</Link>

                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );

}

export default ChoosePlanUnlock;
